import { render } from "./ProcessService.vue?vue&type=template&id=a5e896b4"
import script from "./ProcessService.vue?vue&type=script&lang=js"
export * from "./ProcessService.vue?vue&type=script&lang=js"

import "./ProcessService.vue?vue&type=style&index=0&id=a5e896b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__